<template>
  <b-notification :type="step.status | itemStyle" :closable="false">
    <div class="media is-align-items-center">
      <div class="media-left">
        <div class="icon-stack">
          <b-icon
            pack="fas"
            :icon="step.status | statusIcon"
            size="is-medium"
          />
          <CloudTaskStatus
            v-if="step.taskName && step.status !== 'finished'"
            :taskName="step.taskName"
            class="cloud-task-overlay"
            @status-updated="onTaskStatusUpdated"
            @status-error="onTaskStatusError"
          />
        </div>
      </div>

      <div class="media-content">
        <p
          class="title is-5"
          :class="step.index === nextStepIndex ? 'has-text-primary' : ''"
        >
          Step {{ step.stepNumber }}: {{ step.title }}
        </p>
        <p
          class="subtitle is-6"
          :class="
            step.index < nextStepIndex
              ? ''
              : step.startTime < Date.now()
              ? 'has-text-danger'
              : 'has-text-info'
          "
        >
          <span
            class="subtitle is-6"
            v-if="step.waitSeconds && step.index > nextStepIndex"
          >
            {{ step.waitSeconds | asMmSs }} after last step
            <span v-if="step.startTime">~</span>
          </span>
          <span v-if="step.startTime">
            {{ step.startTime | asDayjsFormat("hh:mm:ss A") }}
          </span>
        </p>
      </div>

      <div v-if="step.status === 'scheduled' && isNext">
        <ButtonTooltip
          tooltip="Skip this step"
          icon-left="step-forward"
          type="is-info"
          @click="$emit('onSkip')"
        />
        <ButtonTooltip
          tooltip="Run this step"
          icon-left="play"
          type="is-primary"
          @click="$emit('onPlay')"
        />
      </div>

      <div v-else-if="step.status === 'skipped'">
        <ButtonTooltip
          v-if="nextStepIndex === step.index + 1"
          tooltip="Reschedule this step"
          icon-left="clock"
          type="is-warning"
          @click="$emit('onReschedule')"
        />
      </div>

      <div v-else-if="step.status === 'failed'">
        <ButtonTooltip
          tooltip="Rerun this step"
          icon-left="redo"
          type="is-primary"
          @click="$emit('onPlay')"
        />
      </div>
    </div>

    <div class="content has-text-left">
      {{ step.description }}
      <div v-for="(log, i) in step.logs" :key="`log${i}`">‣ {{ log }}</div>
    </div>
  </b-notification>
</template>

<script>
import ButtonTooltip from "../../ui/ButtonTooltip.vue";
import CloudTaskStatus from "../../ui/CloudTaskStatus.vue";

export default {
  components: { ButtonTooltip, CloudTaskStatus },

  name: "PipelineStep",

  props: ["step", "nextStepIndex"],

  computed: {
    isNext() {
      return this.step.index === this.nextStepIndex;
    },
  },

  methods: {
    onTaskStatusUpdated(taskStatus) {
      // Emit to parent component for potential state updates
      this.$emit("task-status-updated", {
        stepId: this.step.id,
        taskStatus,
      });
    },

    onTaskStatusError(error) {
      console.error("Cloud Task status error for step", this.step.id, error);
      // Could show a toast notification here if needed
    },
  },

  filters: {
    itemStyle(status) {
      switch (status) {
        case "skipped":
          return "is-dark";
        case "scheduled":
          return "is-warning";
        case "running":
          return "is-info";
        case "finished":
          return "is-success";
        case "failed":
          return "is-danger";
        default:
          return null;
      }
    },

    statusIcon(status) {
      switch (status) {
        case "skipped":
          return "step-forward";
        case "scheduled":
          return "clock";
        case "running":
          return "spinner";
        case "finished":
          return "check";
        case "failed":
          return "exclamation-circle";
        default:
          return null;
      }
    },
  },
};
</script>

<style scoped>
.notification {
  padding: 0.5rem;
  width: 300px;
}

.icon-stack {
  position: relative;
  display: inline-block;
}

.cloud-task-overlay {
  position: absolute;
  bottom: -2px;
  right: -2px;
  z-index: 1;
}
</style>
